// Import packages
import React, {Component} from "react";
import {connect} from "react-redux";
import {Switch} from "antd";

// Import components
import PageWrapper from '../../components/pageContentViews/pageWrapper'
import MediaSelectorModal from "../../components/media/MediaSelectorModal";
import {InputGroup} from "../../components/uiElements/inputGroup";
import {LinkButton} from "../../components/buttons/buttons";
import {LanguageTabs} from "../../components/uiElements/Tabs";
import {MediaFileCard} from "../../components/media/MediaFileCard";

// Import utils
import {
    changeStateField,
    getInputValues,
    getPatchReqData,
    getTranslatableInputValues,
    getTranslationData,
    initTranslations,
    toggleStateField
} from "../../utils/helperFunctions";
import {mapStateToProps} from "../../redux/mapStateToProps";
import {CreateMenu, GetMenuById, UpdateMenuById} from "../../redux/actions";
import {ACCEPT_IMAGE_TYPES} from "../../constants/acceptedTypes";
import {validateTranslations} from "../../utils/validateTranslations";


class AddEditMenu extends Component {
    constructor(props) {
        super(props);
        this.translationsFields = [
            'title',
        ];
        this.state = {
            fieldsData: {
                translations: initTranslations(this.translationsFields, props.activeLanguages),
                pageId: undefined,
                url: '',
                parent: undefined,
                isHidden: false,
            },
            errors: {},
            errorsTabs: [],
            isEditing: !!props?.id,
            languageTab: props.mainLanguage,
            requestLoading: false,
        };
        this.updatedDataMap = new Map();
        this.currentData = null;
        this.changeLanguageTab = changeStateField.bind(this, 'languageTab');
        this.getInputValues = getInputValues.bind(this);
        this.getPatchReqData = getPatchReqData.bind(this);
        this.getTranslationValues = getTranslatableInputValues.bind(this);
        this.addEditMenu = this.addEditMenu.bind(this);
        this.pageOptions = props.customPagesList?.map(customPage => {
            const {id, title} = customPage;
            return {
                id: id,
                name: title,
            }
        })
        console.log(this.pageOptions);

    }

    async componentDidMount() {
        const {isEditing} = this.state;
        const translationsData = {};

        // init Menus Options
        this.menuOptions = [];
        Array.isArray(this.props.menuList) && this.props.menuList.forEach(item => {
            this.menuOptions.push({
                name: item?.title,
                id: item?.id,
            })
        });

        if (isEditing) {
            await this.props.GetMenuById(this.props.id);
            const editingData = this.props.menuById;
            this.menuOptions = this.menuOptions.filter(item => item.id !== this.props.id);
            if (editingData) {

                editingData.translations.forEach(item => {
                    translationsData[item.language] = {
                        ...translationsData[item.language],
                        title: item.title || '',
                    };
                });

            }
            const initStateData = {
                translations: translationsData,
                pageId: editingData?.pageId,
                url: editingData?.url,
                parent: editingData?.parent,
                isHidden: editingData?.isHidden,
            };
            this.currentData = JSON.parse(JSON.stringify(initStateData));
            this.setState({
                ...this.state,
                fieldsData: initStateData
            });

        } else {
            //for menus options
            this.forceUpdate()
        }
    }

    addEditMenu() {
        this.setState({
            requestLoading: true
        });
        const {translations, pageId, url, isHidden, parent} = this.state.fieldsData;
        const translationRequiredFields = ['title']
        const validationTr = validateTranslations(translations, translationRequiredFields)
        let result = validationTr.result;
        const errors = {...validationTr.errors};

        if (result) {
            const trData = getTranslationData(translations)
            if (!this.state.isEditing) {
                const reqData = {
                    isHidden,
                    translations: trData,
                };
                if (url) reqData.url = url;
                if (pageId) reqData.pageId = pageId;
                if (parent) reqData.parent = parent;
                this.props.CreateMenu(reqData)
                    .finally(() => {
                        this.setState({requestLoading: false});
                    })
            } else {
                const reqData = this.getPatchReqData(trData);
                console.log(reqData);
                this.props.UpdateMenuById(this.props.id, reqData)
                    .finally(() => {
                        this.setState({requestLoading: false});
                    });
            }

        } else {
            this.setState({
                requestLoading: false,
                errors: errors,
                errorsTabs: validationTr.errorsTabs
            })
        }
    }


    getPageValue=({value})=> {
        const {fieldsData, isEditing} = this.state;

        // console.log('type', value);
        if (isEditing) {
            if (this.currentData?.pageId) {
                if (!value) {
                    this.updatedDataMap.set("pageId", null);
                } else {
                    value === this.currentData?.pageId ? this.updatedDataMap.delete("pageId") :
                        this.updatedDataMap.set("pageId", value);
                }
            } else {
                value ? this.updatedDataMap.set("pageId", value) :
                    this.updatedDataMap.delete("pageId");
            }
            this.updatedDataMap.set("url", '');
        }

        this.setState({
            fieldsData: {
                ...fieldsData,
                pageId: value,
                url: ''
            }
        })
    }

    render() {
        const {fieldsData, errors, languageTab, mediaModalOpen, requestLoading, isEditing, errorsTabs} = this.state;
        const initData = this.currentData?.translations[languageTab] || {};
        const currentData = fieldsData.translations[languageTab] || {};

        return <PageWrapper pageTitle={!isEditing ? 'Ավելացնել հղում' : 'Փոփոխել հղումը'}>
            <section className="general-add-edit">
                <div className="fixed-top-right">
                    <label>{!fieldsData.isHidden ? "Ակտիվ " : "Ոչ ակտիվ "}</label>
                    <Switch checked={!fieldsData.isHidden}
                            onChange={(checked) => this.getInputValues({
                                name: "isHidden",
                                value: !checked,
                                haveChanges: this.currentData?.isHidden !== !checked
                            })}/>
                </div>
                <InputGroup inputType="wrapper"
                            label={"Ծնող հղում"}>
                    <InputGroup inputType="selectCustom"
                                name="parent"
                                value={fieldsData.parent}
                                initValue={this.currentData?.parent}
                                withClear={true}
                                placeholder={'Ծնող հղում'}
                                onChange={this.getInputValues}
                                options={this.menuOptions}
                    />
                </InputGroup>
                <InputGroup inputType="selectCustom"
                            placeholder="Էջ"
                            label="Էջ"
                            name="pageId"
                            showSearch={false}
                            withClear={true}
                            value={fieldsData?.pageId}
                            disabled={fieldsData?.url}
                            onChange={this.getPageValue}
                            options={this.pageOptions}/>
                <InputGroup inputType="input"
                            type="text"
                            label="Հղում"
                            placeholder="Հղում"
                            name="url"
                            disabled={fieldsData?.pageId}
                            value={fieldsData?.url}
                            initValue={this.currentData?.url}
                            error={errors?.url}
                            maxLength={500}
                            onChange={this.getInputValues}/>


                <LanguageTabs changeLanguageTab={this.changeLanguageTab}
                              errorsTabs={errorsTabs}
                              activeTab={languageTab}
                />
                <div className="category-left-part">
                    <InputGroup inputType="input"
                                type="text"
                                label="Անվանում"
                                placeholder="Անվանում"
                                name="title"
                                value={currentData.title}
                                initValue={initData.title}
                                error={errors['title' + languageTab]}
                                maxLength={100}
                                required={true}
                                onChange={this.getTranslationValues}/>

                </div>
                <div className="flex-wrapper-right">
                    <LinkButton title={!isEditing ? 'Ավելացնել' : 'Փոփոխել'}
                                loading={requestLoading}
                                disabled={isEditing && !this.updatedDataMap.size}
                                cb={this.addEditMenu}/>
                </div>

            </section>
            <MediaSelectorModal
                isOpen={!!mediaModalOpen}
                acceptTypes={ACCEPT_IMAGE_TYPES}
                getMedia={this.getMedia}
                closeModal={this.toggleMediaModal}
            />
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    CreateMenu,
    GetMenuById,
    UpdateMenuById
};

export default connect(mapStateToProps, mapDispatchToProps)(AddEditMenu)
